<template minapp='mpx' xlang='wxml'>
  <view class="es-content__box es-content__card es-content__save-btn" wx:if="{{showSaveSwitch}}">
    <view class="es-content__save-btn-left">
      <view class="es-content__save-btn-text">保存为常用出行人</view>
      <view class="es-content__save-btn-icon" catchtap="btnIconTap">
        <es-icon name="info-circle" color="#999999" />  
      </view>
      <view class="es-content__save-btn-toast" wx:if="{{innerShowSaveIconToast}}">
        <view class="es-content__save-btn-icon-toast-triangle"></view>
        <view class="es-content__save-btn-icon-toast">新增出行人信息将同步至您的常用出行人列表，方便您下次快捷预订，您可以选择手动关闭该按钮</view>
      </view>
    </view>
    <view class="es-content__save-btn-right" bindtap="changeSaveBtn" wx:class="{{ innerValue?'':'es-content__save-btn-right-bg' }}">
      <view class="es-content__save-btn-right-inner" wx:class="{{ innerValue?'es-content__save-btn-right-inner-open':'es-content__save-btn-right-inner-close' }}"></view>
    </view>
  </view>
</template>

<script>
import { watch } from "@mpxjs/core";
import Toast from '@didi/es-mpx-ui/lib/toast/functional'

import { createComponent } from '@didi/es-mpx-creator'

createComponent({
  classes: [],
  data: {
    innerValue:'',
    innerShowSaveIconToast:false
  },
  props: {
    value:{
      type: Boolean,
      value: ''
    },
    showSaveSwitch:{
      type: Boolean,
      value: false
    },
  },
  computed: {
    
  },
  methods: {
    btnIconTap() {
      this.innerShowSaveIconToast = !this.innerShowSaveIconToast
    },
    changeSaveBtn() {
      this.innerValue = !this.innerValue
      if (!this.innerValue) {
        Toast({
          message:
            '关闭后，您本次录入的出行人信息将不会同步至常用出行人列表，再次预订时仍需您手动添加。',
          overlay: false,
          duration: 3000,
        })
      }
    },
    hideSaveIconToast() {
      this.innerShowSaveIconToast = false
    }
  },
  watch:{
    value(val) {
      this.innerValue = val
    },
    //将数据回传
    innerValue(newValue) {
      this.$trigger( 'input', {value:newValue} )
    },
  }
})
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('box')
      margin 12px
    +e('card')
      background-color #ffffff
      border-radius 8px
      color #333333
      /deep/ .placeholder
        color #999999
      // h5用
      /deep/ .es-card__header
        line-height 38px
        font-size 16px
        font-weight bold
        margin 4px 12px
        padding 0
        border-bottom 0.5px solid #ebedf0
      // h5用
      /deep/ .es-cell
        height 54px
        color #333333
        padding 10px 0
        &::after
          border-bottom 1px solid #f0f2f7
          left 76px
          right 0
      // h5用
      /deep/ .es-cell:last-child
        &::after
          border-bottom none
      // h5用
      /deep/ .es-cell-custom
        height 44px
        &::after
          border-bottom 1px solid #eeeeee
          left 0
          right 0
      // h5用
      /deep/ .es-cell-custom:last-child
        &::after
          border-bottom 1px solid #eeeeee
      // h5用
      /deep/ .es-field__body
        color #333333 !important
    // 小程序用
    +e('save-btn')
      display flex
      align-items center
      justify-content space-between
    +e('save-btn-left')
      display flex
      align-items center
      position relative
    +e('save-btn-text')
      font-family PingFangSC-Regular
      font-size 15px
      color #333333
      padding 15px 4px 15px 12px
    +e('save-btn-right')
      display flex
      position relative
      width 40px
      height 24px
      background #1473FF
      border-radius 20px
      margin-right 12px
    +e('save-btn-right-inner')
      width 20px
      border-radius 20px
      height 20px
      background #FFFFFF
      position absolute
      top 2px
      left 2px
    +e('save-btn-right-inner-open')
      transform translateX(16px)
      transition all 0.2s
    +e('save-btn-right-inner-close')
      transform translateX(0px)
      transition all 0.2s
    +e('save-btn-right-bg')
      background #cccccc
    +e('save-btn-icon')
      color #999999
      margin-left 2px
      padding-right 20px
      height 30px
      display flex
      align-items center
    +e('save-btn-icon-toast')
      display flex
      align-items center
      justify-content center
      padding 0 8px
      position absolute
      top 20px
      left 8px
      z-index 1
      font-family PingFangSC-Regular
      font-size 12px
      color #FFFFFF
      letter-spacing 0
      font-weight 400
      width 300px
      height 50px
      opacity 0.74
      background #000000
      border-radius 6px
    +e('save-btn-icon-toast-triangle')
      position absolute
      top 10px
      left 140px
      width 0
      height 0
      border-left 5px solid transparent
      border-right 5px solid transparent
      border-bottom 10px solid rgba(0, 0, 0, 0.74)
    +e('save-btn-toast')
      position absolute
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
    }
  }
</script>

